import * as React from 'react';
import { I18n, ConsoleLogger as Logger } from '@aws-amplify/core';
import Auth from '@aws-amplify/auth';

import { AuthPiece } from 'aws-amplify-react';
import AmplifyTheme from 'aws-amplify-react/lib/Amplify-UI/Amplify-UI-Theme';

import client from 'helpers/client';

import {
  FormSection,
  SectionHeader,
  SectionBody,
  SectionFooter,
  Input,
  RadioRow,
  Button,
  Link,
  SectionFooterPrimaryContent,
  SectionFooterSecondaryContent,
} from 'aws-amplify-react/lib/Amplify-UI/Amplify-UI-Components-React';

import { auth } from 'aws-amplify-react/lib/Amplify-UI/data-test-attributes';
import paths from '../../redux/paths';
import cognito from '../../helpers/cognito';

const logger = new Logger('VerifyContact');


export default class VerifyContact extends AuthPiece {
  constructor(props) {
    super(props);

    this._validAuthStates = ['verifyContact'];
    this.verify = this.verify.bind(this);
    this.submit = this.submit.bind(this);

    this.state = { verifyAttr: "" };
  }

  verify() {
    const { contact, checkedValue } = this.inputs;
    if (!contact) {
      this.error('Neither Email nor Phone Number selected');
      return;
    }

    if (!Auth || typeof Auth.verifyCurrentUserAttribute !== 'function') {
      throw new Error(
        'No Auth module found, please ensure @aws-amplify/auth is imported'
      );
    }

    Auth.verifyCurrentUserAttribute(checkedValue)
      .then(data => {
        logger.debug(data);
        this.setState({ verifyAttr: checkedValue });
      })
      .catch(err => this.error(err));
  }

  submit() {
    console.log("submit");
    const attr = this.state.verifyAttr;
    const { code } = this.inputs;
    if (!Auth || typeof Auth.verifyCurrentUserAttributeSubmit !== 'function') {
      throw new Error(
        'No Auth module found, please ensure @aws-amplify/auth is imported'
      );
    }

    let authData = this.props.authData
    let attributes = authData.attributes
    console.log('authData', authData)
    let email = attributes ? attributes.email : authData.unverified.email;
    let username = authData.username;
    Auth.verifyCurrentUserAttributeSubmit(attr, code)
      .then(data => {
        logger.debug(data);
        this.changeState('signedIn', this.props.authData);
        this.setState({ verifyAttr: null });
        // call api lên server để gửi mail cho admin báo đã có email của người dùng verified
        cognito.getHeaderAuthorization().then(dataCognito => {
          client.sendRequest({
            path: paths.SEND_MAIL_WHEN_VERIFY_EMAIL,
            method: 'POST',
            params: { email, username },
            headers: dataCognito,
          }).then((data) => { })
        })
      })
      .catch(err => this.error(err));
  }

  verifyView() {
    const user = this.props.authData;
    if (!user) {
      logger.debug('no user for verify');
      return null;
    }
    const { unverified } = user;
    if (!unverified) {
      logger.debug('no unverified on user');
      return null;
    }
    const { email } = unverified;
    const theme = this.props.theme || AmplifyTheme;
    return (
      <div>
        <RadioRow
          placeholder={I18n.get('Email')}
          theme={theme}
          key="email"
          name="contact"
          value="email"
          onChange={this.handleInputChange}
        />
      </div>
    );
  }

  submitView() {
    const theme = this.props.theme || AmplifyTheme;
    return (
      <div>
        <Input
          placeholder={I18n.get('Code')}
          theme={theme}
          key="code"
          name="code"
          autoComplete="off"
          onChange={this.handleInputChange}
        />
      </div>
    );
  }

  showComponent(theme) {
    const { authData, hide } = this.props;
    if (hide && hide.includes(VerifyContact)) {
      return null;
    }

    return (
      <FormSection theme={theme} data-test={auth.verifyContact.section}>
        <SectionHeader
          theme={theme}
          data-test={auth.verifyContact.headerSection}
        >
          {I18n.get('Account recovery requires verified contact information')}
        </SectionHeader>
        <SectionBody theme={theme} data-test={auth.verifyContact.bodySection}>
          {this.state.verifyAttr ? this.submitView() : this.verifyView()}
        </SectionBody>
        <SectionFooter theme={theme}>
          <SectionFooterPrimaryContent theme={theme}>
            {this.state.verifyAttr ? (
              <Button
                theme={theme}
                onClick={this.submit}
                data-test={auth.verifyContact.submitButton}
              >
                {I18n.get('Submit')}
              </Button>
            ) : (
              <Button
                theme={theme}
                onClick={this.verify}
                data-test={auth.verifyContact.verifyButton}
              >
                {I18n.get('Verify')}
              </Button>
            )}
          </SectionFooterPrimaryContent>
          {/*<SectionFooterSecondaryContent theme={theme}>*/}
          {/*<Link*/}
          {/*theme={theme}*/}
          {/*onClick={() => this.changeState('signedIn', authData)}*/}
          {/*data-test={auth.verifyContact.skipLink}*/}
          {/*>*/}
          {/*{I18n.get('Skip')}*/}
          {/*</Link>*/}
          {/*</SectionFooterSecondaryContent>*/}
        </SectionFooter>
      </FormSection>
    );
  }
}
